function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CurrentApplicationSelector } from 'invision-core/src/components/application/application.selectors';
import { setApplicationVersion } from 'invision-core/src/components/application/application.actions';
import * as Version from '../../version';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { FaultJustHandledSelector } from 'invision-core/src/components/fault/fault.selectors';
import { info } from 'invision-core/src/components/helpers/log.helper';
import { IsLoadingModuleSelector } from 'invision-core/src/components/session/session.selectors';
import { isInIframeOrWebView } from 'invision-core/src/utilities/message.helpers';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    currentApplication: CurrentApplicationSelector(store),
    faultJustHandled: FaultJustHandledSelector(store),
    isLoadingModule: IsLoadingModuleSelector(store)
  };
};
var controllerActions = {
  setApplicationVersion: setApplicationVersion
};
var MainController = /*#__PURE__*/function () {
  function MainController($ngRedux, SessionService) {
    _classCallCheck(this, MainController);
    this.$ngRedux = $ngRedux;
    this.CoreLocaleKeys = CoreLocaleKeys;
    this.SessionService = SessionService;
    this.disableSessionTimeout = isInIframeOrWebView();
  }
  return _createClass(MainController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.actions.setApplicationVersion(Version);
      this.SessionService.load();
      info('Invision application initialized successfully.');
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./main.html'),
  controller: MainController
};